import type { FC } from "react";
import CompanyAdminSidebar from "./CompanyAdminSidebar";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { isAdminTierUser } from "../constants/agent";

/**
 * @deprecated Kept for backward-compat with code that still imports it.
 * The single sidebar shows different items by role via useEffectiveRoles.
 */
export const useIsAdminUser = () => {
    const currentUser = useCurrentUser();
    return (
        isAdminTierUser(currentUser)
    );
};

const AppSidebar: FC = function () {
    return <CompanyAdminSidebar />;
};

export default AppSidebar;
